import { Tab } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import PersonalInfoTab from "./PersonalInfoTab";
import AchievementsTab from "./AchievementsTab";
import LearningHistoryTab from "./LearningHistoryTab";

interface ProfileTabsProps {
  user: any;
  companyData?: any;
  isEditing: boolean;
  formData: {
    fullName: string;
    email: string;
    phoneNumber: string;
    photo: string;
    logo: string;
  };
  companyName: string;
  fileInputRef: React.RefObject<HTMLInputElement>;
  getImageUrl: (photo: string) => string;
  onEditClick: () => void;
  onCancelEdit: () => void;
  onFormDataChange: (field: string, value: string) => void;
  onCompanyNameChange: (value: string) => void;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFileInputClick: () => void;
  onSubmit: (e: React.FormEvent) => void;
  isSubmitting: boolean;
}

const ProfileTabs = ({
  user,
  companyData,
  isEditing,
  formData,
  companyName,
  fileInputRef,
  getImageUrl,
  onEditClick,
  onCancelEdit,
  onFormDataChange,
  onCompanyNameChange,
  onFileChange,
  onFileInputClick,
  onSubmit,
  isSubmitting,
}: ProfileTabsProps) => {
  const { t } = useTranslation();

  return (
    <div className="md:col-span-2">
      <Tab.Group>
        <Tab.List className="mb-8 flex space-x-2 rounded-xl bg-gray-100 p-2 dark:bg-gray-800 shadow-lg">
          <Tab
            className={({ selected }) =>
              `w-full rounded-lg py-3 text-sm font-medium leading-5 ring-white ring-opacity-60 ring-offset-2 ring-offset-primary-400 focus:outline-none focus:ring-2 transition-all duration-300 ${
                selected
                  ? "bg-gradient-to-r from-primary-600 to-primary-700 text-white shadow-lg transform scale-105"
                  : "text-gray-600 hover:bg-white/[0.12] hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-100 hover:scale-105"
              }`
            }
          >
            {t("profile.personalInfo")}
          </Tab>
          <Tab
            className={({ selected }) =>
              `w-full rounded-lg py-3 text-sm font-medium leading-5 ring-white ring-opacity-60 ring-offset-2 ring-offset-primary-400 focus:outline-none focus:ring-2 transition-all duration-300 ${
                selected
                  ? "bg-gradient-to-r from-primary-600 to-primary-700 text-white shadow-lg transform scale-105"
                  : "text-gray-600 hover:bg-white/[0.12] hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-100 hover:scale-105"
              }`
            }
          >
            {t("profile.achievements")}
          </Tab>
          <Tab
            className={({ selected }) =>
              `w-full rounded-lg py-3 text-sm font-medium leading-5 ring-white ring-opacity-60 ring-offset-2 ring-offset-primary-400 focus:outline-none focus:ring-2 transition-all duration-300 ${
                selected
                  ? "bg-gradient-to-r from-primary-600 to-primary-700 text-white shadow-lg transform scale-105"
                  : "text-gray-600 hover:bg-white/[0.12] hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-100 hover:scale-105"
              }`
            }
          >
            {t("profile.learningHistory")}
          </Tab>
        </Tab.List>

        <Tab.Panels>
          <Tab.Panel>
            <PersonalInfoTab
              user={user}
              companyData={companyData}
              isEditing={isEditing}
              formData={formData}
              companyName={companyName}
              fileInputRef={fileInputRef}
              getImageUrl={getImageUrl}
              onEditClick={onEditClick}
              onCancelEdit={onCancelEdit}
              onFormDataChange={onFormDataChange}
              onCompanyNameChange={onCompanyNameChange}
              onFileChange={onFileChange}
              onFileInputClick={onFileInputClick}
              onSubmit={onSubmit}
              isSubmitting={isSubmitting}
            />
          </Tab.Panel>

          <Tab.Panel>
            <AchievementsTab user={user} />
          </Tab.Panel>

          <Tab.Panel>
            <LearningHistoryTab user={user} />
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};

export default ProfileTabs;
